// TODO
export const electionApiProductionUrl = "https://api.rezultatevot.ro/api";
export const electionMapOverlayUrl = "https://rezultatevot-map-files.s3.eu-central-1.amazonaws.com";
